import { useEffect, useState } from 'react'

import { getHomePanels } from '../Contentful'

export default function useHomePanels() {
  const promise = getHomePanels()
  // console.log("test 3");
  const [homePanels, setHomePanels] = useState(null)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    promise.then(result => {
      setHomePanels(result)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [homePanels, isLoading]
}